import React from "react";
import PropTypes from "prop-types";
import SelectSearch from "@components/Form/SelectSearch";

const RegionSelect = ({
  regions,
  currentRegion,
  defaultLabel,
  handleRegionChange,
  maxMenuHeight,
  menuPlacement,
}) => {
  const options = regions.map(({ url_key, name }) => ({
    value: url_key,
    label: name,
  }));
  const defaultValue = {
    value: "",
    label: defaultLabel || "Selecteaza o regiune",
  };
  const selected =
    currentRegion && regions.find((region) => region.url_key === currentRegion);
  const value = selected
    ? {
        value: selected.url_key,
        label: selected.name,
      }
    : defaultValue;

  return (
    <div className="relative z-10 min-w-[190px]">
      <SelectSearch
        input={{
          value: value,
          onChange: ({ value }) => handleRegionChange(value),
        }}
        options={[defaultValue, ...options]}
        maxMenuHeight={maxMenuHeight}
        menuPlacement={menuPlacement}
      />
    </div>
  );
};

RegionSelect.propTypes = {
  regions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      url_key: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  currentRegion: PropTypes.string,
  handleRegionChange: PropTypes.func.isRequired,
};

export default RegionSelect;
